import React, { useMemo } from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import MuiFab, { FabProps as MuiFabProps } from '@material-ui/core/Fab';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import classnames from 'classnames';

const styles = ({
  palette: { primary },
  custom: {
    palette: { colorSupportPowder },
  },
}: Theme) =>
  createStyles({
    root: {},
    /* Styles applied to the root element if `color="supportPowder"`. */
    colorSupportPowder: {
      color: primary.main,
      backgroundColor: colorSupportPowder,
      '&:hover': {
        backgroundColor: emphasize(colorSupportPowder, 0.12),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: colorSupportPowder,
        },
      },
    },
  });

export interface FabProps extends Omit<MuiFabProps, 'classes' | 'color'>, WithStyles<typeof styles> {
  color?: MuiFabProps['color'] | 'supportPowder';
}

const Fab: React.FC<FabProps> = ({ classes: classesProp, className, color: colorProp, ...rest }) => {
  const color = useMemo(() => {
    if (colorProp === 'supportPowder') {
      return 'primary';
    }
    return colorProp;
  }, [colorProp]);

  const classes = useMemo(() => {
    const res: MuiFabProps['classes'] = {
      root: classnames(
        {
          [classesProp.colorSupportPowder]: colorProp === 'supportPowder',
        },
        className,
      ),
    };
    return res;
  }, [className, classesProp, colorProp]);

  return <MuiFab classes={classes} color={color} {...rest} />;
};

export default withStyles(styles, { name: 'Fab' })(Fab);
